import {Button, Link, TextField, Typography, Select, MenuItem, Checkbox, FormControlLabel, Tooltip} from "@material-ui/core"
import {useState, useEffect, useContext} from "react";
import TextractContext from "../../contexts/TextractContext";
import InvoyageTooltip from "./bill/InvoyageTooltip";
import axiosAuth from "../../utils/axiosWithAuth";
import Loader from "react-loader-spinner";
import SnackbarLoader from "./snackbar/SnackbarLoader"
import TextractIndexTable from "./TextractIndexTable"
import CompanySelector from "./CompanySelector";
import { useUser } from "../../contexts/UserContext";
import ClientSelector from "./ClientSelector";
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import ShareIcon from '@material-ui/icons/Share';

const NULL_COMPANY_SELECTOR = {id: null, name: "No Company Selected"}
export default function Index() {
  const [loading, setLoading] = useState(false)
  const [copySnackbarOpen, setCopySnackbarOpen] = useState(false)
  const {user} = useUser()
  const [inferAccountNum, setInferAccountNum] = useState(false)
  const {setFetchNew, textractBills, setTextractBills, selectedTextractBill, setSelectedTextractBill, setSelectedTextractBillId, setSnackbar, utilityCompanies, CLIENTS} = useContext(TextractContext)

  const [selectedUploaderUtility, setSelectedUploaderUtility] = useState(NULL_COMPANY_SELECTOR)
  
  const [selectedClient, setSelectedClient] = useState(CLIENTS.find(c => c.id == user.company_id))

  const onFileLoad = (e, utility_company_id, inferAccountNum) => {
    const {files} = e.target;
    console.log(files)
    if (e.target.files[0]) {
      if (utility_company_id == 'null' && !window.confirm(`You are about to upload files without specifying a utility company. If you know the provider from whom the bills came, please cancel and select a utility company from the selector before uploading.`)) {
        e.target.value = "";
        return
      }
      setLoading(true)
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('fileData[]', files[i]);
      }
      formData.append("utility_company_id", utility_company_id == "null" ? null : utility_company_id)
      if (user.admin) {
        formData.append("company_id", selectedClient.id)
      }
      formData.append("inferAccountNum", inferAccountNum)
       
      setSnackbar({message: "Extracting Data...", severity: "info",  loader: <SnackbarLoader /> })
      axiosAuth().post(`${user.admin ? "/admin/textract_bills" : "/documents"}/upload`, formData, {headers: {"Content-Type": "multipart/form-data"}})
      .then(r => {
        console.log(r)
        setSnackbar({message: r.data.message || "Upload complete", severity: "success"})
        e.target.value = "";
        setLoading(false)
      }).catch(err => {
        setLoading(false)
        setSnackbar({message: "Extraction Failed.", severity: "error"})
        console.log(err)
        e.target.value = "";
        
      })
    }
  }

  return (
    <div>            
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 10}}>

        <Typography variant="p">Upload Files:&nbsp;</Typography>
        {user.admin && <ClientSelector 
          clients={CLIENTS}
          selectedClient={selectedClient}
          handleChange={(e, newValue)=> setSelectedClient(newValue)}
          style={{ width: 400, marginRight: 20}}
        />}
        <CompanySelector 
          utilityCompanies={utilityCompanies}
          selectedUtilityCompany={selectedUploaderUtility}
          handleChange={(e, newValue)=> setSelectedUploaderUtility(newValue || NULL_COMPANY_SELECTOR)}
          style={{ width: 400, marginRight: 20}}
        />
        {user.admin && <FormControlLabel
          control={
            <Checkbox
              checked={inferAccountNum}
              onChange={(e) => setInferAccountNum(e.target.checked)}
              color="primary"
            />
          }
          label={
            <InvoyageTooltip title="Toggle to specify the account number in the filename. Your file must be named according to the following convention: `UtilityCompanyName_AccountNumber_InvoiceDateAsYYYYMMDD.pdf`.">
              <span>Follows filename convention</span>
            </InvoyageTooltip>
          }
          style={{
            marginLeft: 8
          }}
        />}
        <TextField
          fillWidth
          inputProps={{
            multiple: true
          }}
          style={{display: 'block'}}
          name='fileData[]'
          type='file' 
          onChange={e => onFileLoad(e, selectedUploaderUtility.id, inferAccountNum)} />
        {user.company_uuid && <Tooltip title="Copy a bill upload link that is shareable with other stakeholders (i.e., AP Department, Site Managers)">
          <IconButton
            onClick={() => {
              navigator.clipboard.writeText(`${process.env.REACT_APP_URL}/file-upload/${user.company_uuid}`);
              setCopySnackbarOpen(true);
            }}
            style={{ marginLeft: '8px' }}
          >
            <ShareIcon color='primary' />
          </IconButton>
        </Tooltip>}
        <Loader
          style={{opacity: loading ? 1 : 0, marginLeft: "8px"}}
          type="Grid"
          height={40}
          color = 'orange'
          width={40} /> 
      </div>

      <TextractIndexTable
        setTextractBills={setTextractBills}
        setSelectedTextractBillId={setSelectedTextractBillId}
      />
      <Snackbar
        open={copySnackbarOpen}
        autoHideDuration={3000}
        onClose={() => setCopySnackbarOpen(false)}
        message="Copied Link"
      />
    </div>
  )
}